import { ApiInstance } from '@src/services/api-instance';

import { LutienV1Service } from './modules/v1/lutien-api-v1';

export class LutienApi {
  private client: ApiInstance;

  public v1: LutienV1Service;

  constructor(client?: ApiInstance) {
    this.client = client || new ApiInstance(import.meta.env.VITE_LUTIEN_BASE_URL, 30000);

    this.v1 = new LutienV1Service(this.client);
  }
}
